import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const FiltersContainer = styled(ToggleButtonGroup, {
  shouldForwardProp: (prop) =>
    prop !== 'hasCustomStyles' && prop !== 'hasDisplayBlock',
})(({ theme, hasCustomStyles, hasDisplayBlock }) => {
  if (hasCustomStyles)
    return {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: theme.palette.colors.primaryBackground,
      padding: '20px 17px 0',
      borderRadius: 0,
    };

  return {
    display: hasDisplayBlock && 'block',
  };
});

export const ToggleFilterStyled = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== 'hasCustomStyles',
})(({ theme, hasCustomStyles }) => ({
  padding: hasCustomStyles ? '9px 10px 8px' : '6px 8px 5px',
  borderRadius: '4px !important',
  textTransform: !hasCustomStyles && 'capitalize',
  border: `solid 1px ${theme.palette.colors.lower} !important`,
  backgroundColor: theme.palette.colors.primaryBackground,
  fontSize: '12px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  lineHeight: 'normal',
  transform: '',
  color: theme.palette.colors.onPrimaryBackground,
  '&.Mui-selected': {
    backgroundColor: theme.palette.colors.mainFocused,
    color: theme.palette.colors.onIconsAndTextButtonsVariant,
    border: '0 !important',
  },
  '&:not(:last-of-type)': {
    margin: '0 8px 0 0',
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.primaryBackground,
  },
}));
